module.exports = __webpack_public_path__ + "img/iec.25956c16.png";